/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ObservationsMapParameterDisplayGroup } from './observations-map-parameter-display-group';
// May contain unused imports in some cases
// @ts-ignore
import type { ObservationsMapParameterMapLayerConfiguration } from './observations-map-parameter-map-layer-configuration';
// May contain unused imports in some cases
// @ts-ignore
import type { ParameterTimeSeriesConfiguration } from './parameter-time-series-configuration';
// May contain unused imports in some cases
// @ts-ignore
import type { ParametersGeoBoundingBox } from './parameters-geo-bounding-box';
// May contain unused imports in some cases
// @ts-ignore
import type { StaticMapOverlaysOverlayConfiguration } from './static-map-overlays-overlay-configuration';

/**
 * 
 * @export
 * @interface ObservationsMapWidgetConfigurationAllOf
 */
export interface ObservationsMapWidgetConfigurationAllOf {
    /**
     * 
     * @type {string}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'type': ObservationsMapWidgetConfigurationAllOfTypeEnum;
    /**
     * 
     * @type {ParametersGeoBoundingBox}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'initial_viewport_bounds': ParametersGeoBoundingBox;
    /**
     * 
     * @type {string}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'base_layer_style': ObservationsMapWidgetConfigurationAllOfBaseLayerStyleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'show_all_locations': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'weather_stations_enabled_by_default': boolean;
    /**
     * 
     * @type {Array<ParameterTimeSeriesConfiguration>}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'parameter_time_series_configurations': Array<ParameterTimeSeriesConfiguration>;
    /**
     * 
     * @type {Array<ObservationsMapParameterMapLayerConfiguration>}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'parameter_map_layer_configurations': Array<ObservationsMapParameterMapLayerConfiguration>;
    /**
     * 
     * @type {Array<StaticMapOverlaysOverlayConfiguration>}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'static_map_overlay_configurations': Array<StaticMapOverlaysOverlayConfiguration>;
    /**
     * 
     * @type {Array<ObservationsMapParameterDisplayGroup>}
     * @memberof ObservationsMapWidgetConfigurationAllOf
     */
    'parameter_display_groups': Array<ObservationsMapParameterDisplayGroup>;
}

export const ObservationsMapWidgetConfigurationAllOfTypeEnum = {
    ObservationsMap: 'observations_map'
} as const;

export type ObservationsMapWidgetConfigurationAllOfTypeEnum = typeof ObservationsMapWidgetConfigurationAllOfTypeEnum[keyof typeof ObservationsMapWidgetConfigurationAllOfTypeEnum];
export const ObservationsMapWidgetConfigurationAllOfBaseLayerStyleEnum = {
    FullColor: 'full_color',
    Monochrome: 'monochrome'
} as const;

export type ObservationsMapWidgetConfigurationAllOfBaseLayerStyleEnum = typeof ObservationsMapWidgetConfigurationAllOfBaseLayerStyleEnum[keyof typeof ObservationsMapWidgetConfigurationAllOfBaseLayerStyleEnum];


